import { Navigate, Outlet } from "react-router-dom";
import { useAPI } from "../contexts/APIContext";

/**
 * Protects routes that require authentication
 *
 * This component now focuses solely on rendering protected content,
 * while the AuthGuard handles redirects in a more seamless way.
 */
export default function ProtectedRoute() {
  const { user, loading } = useAPI();

  if (loading) {
    // You could render a spinner here
    return (
      <div className="min-h-screen flex justify-center items-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  // Simply render the outlet if user exists, AuthGuard handles redirection
  return user ? <Outlet /> : <Navigate to="/login" replace />;
}
